import { Collapse, Typography } from "antd";
import styled from "styled-components";

export const StyledCollapse = styled(Collapse)`
  margin: 12px 24px;

  border-radius: 8px;

  .ant-collapse-item {
    background-color: #ffffff;
  }

  .arrow-icon {
    display: flex;
    align-items: center;
  }

  .ant-collapse-item-active  .arrow-icon {
    transform: rotate(180deg);
  }

  .ant-collapse-item-active {
    background-color: #f7f9fe;
    border-radius: 8px !important;
  }

  .ant-collapse-header {
    display: flex;
    align-items: center;

    &:hover {
      opacity: 0.8;
    }
  }

  & > .ant-collapse-item > .ant-collapse-header {
    padding: 16px 16px 0px;
  }

  & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 16px;
  }
`;

export const StyledText = styled(Typography.Text)`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-left: 12px;
`;
